const state = {
    ticket: [],
    ticketId:[],
    loading: false
};

export default state;